<template>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10 align-self-center">
          <h2>{{ $t('navigations.site user dashboard')}}</h2>
      </div>
      <div class="col-lg-2 text-end align-self-center" v-if="defaultdashboard != 'siteuserdashboard'">
        <button type="button" class="btn btn-setdefault fontprop" @click="setasdefault()">{{ $t('navigations.set as default')}}</button>
      </div>
  </div>
    <div class="wrapper wrapper-content">
 <div class="row">

  <!-- <div class="col-lg-3 mb-1 pr-0 pl-1">
    <div class="dash-widget cursor-pointer" @click.prevent="$router.push('/listform')">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.forms')}}</h4>
          <h1 class="font-bold">{{formcountstd}}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_newforms.png">
        </div>
      </div>
    </div>
  </div> -->
  <div class="col-lg-3 mb-1 pr-0 pl-1">
    <div class="dash-widget cursor-pointer">
      <!-- @click.prevent="$router.push('/patientlist')" -->
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.total subjects')}}</h4>
          <h1 class="font-bold">{{patientcountstd }}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_totalsubjects.png">
        </div>
      </div>
    </div>
  </div>
 <div class="col-lg-3 mb-1 pr-0 pl-1">
  <!-- @click.prevent="$router.push('/patientlist')" -->
    <div class="dash-widget cursor-pointer">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.completed subjects')}}</h4>
          <h1 class="font-bold">{{completedpatients }}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_totalsubjects.png">
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3 mb-1 pr-0 pl-1">
    <div class="dash-widget cursor-pointer" @click.prevent="goToQueryList('Open')">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.open queries')}}</h4>
          <h1 class="font-bold">{{openQueryCount}}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_open_queries.png">
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3 mb-1 pr-0 pl-1">
    <div class="dash-widget cursor-pointer" @click.prevent="goToQueryList('Closed')">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.closed queries')}}</h4>
          <h1 class="font-bold">{{closedQueryCount}}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_open_queries.png">
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="col-lg-3 mb-1 pr-0 pl-1">
    <div class="dash-widget cursor-pointer" @click.prevent="$router.push('/sitelist')">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.total sites')}}</h4>
          <h1 class="font-bold">{{sitecountstd}}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_totalsites.png">
        </div>
      </div>
    </div>
  </div> -->

  

</div>
 <div class="row mt-2">
    <div class="col-lg-12">
           <div class="ibox-body">
    <div class="ibox-title style_2 d-flex justify-content-between align-items-center py-0">
    <div class="d-flex align-items-center">
        <ul class="nav nav-tabs border-0" role="tablist">
            <li role="presentation">
                <a :class="{ activeTab: currentView === 'subject' }" @click="showSubjectList">
                    Subject Profile
                </a>
            </li>
            <li role="presentation">
                <a :class="{ activeTab: currentView === 'reconsent' }" @click="showReconsentList">
                    Reconsent Required Subjects
                </a>
            </li>
        </ul>
    </div>
    <div class="d-flex">
        <!-- existing filter/create icons (unchanged) -->
        <div class="position-relative align-self-center" :class="{ 'mr-3': patientLists.length != 0 }" v-if="roleprivileges.includes('Subjects Create Subject')" aria-label="Create subject" tabindex="0">
            <img width="17" height="17" class="cursor-pointer" src="../../assets/img/create.png" alt="Create subject" @click="editPatient('0')" />
            <div class="tool-tip">{{ $t("navigations.create subject") }}</div>
        </div>
        <div class="position-relative cursor-pointer" v-if="patientLists.length != 0" @click.prevent="showFilter = !showFilter">
            <img src="../../assets/img/filter.png" width="17" height="17" alt="filter table" />
            <div class="tool-tip">{{ $t("navigations.filter") }}</div>
        </div>
    </div>
</div>
      <div class="ibox-content">
        <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
          <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
            <div
              class=" table-multi-select-dropdown"
              @click.stop="dropdownOpen = !dropdownOpen"
            >
              <div class="selected-options">
                <span>{{ $t("navigations.select columns") }}</span>
              </div>
              <div class="dropdown-arrow"></div>
            </div>
            <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
              <label v-for="(column, index) in getColumns" :key="index">
                <input
                  type="checkbox"
                  v-model="selectedcolumnobj[column]"
                  :value="true"
                />
                {{ column }}
              </label>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="showLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
        <div v-else class="table-responsive">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Site Code']">
                  {{ $t("navigations.site code") }}
                </th>
                <th v-if="selectedcolumnobj['Subject ID']">
                  {{ $t("navigations.subject id") }}
                </th>
                <th
                  v-if="selectedcolumnobj['Status']"
                  @click="SortSelected('status', 3)"
                  id="3"
                >
                  <div class="sort_block">
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.status") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </div>
                </th>
                 <!-- <th
                  v-if="selectedcolumnobj['Invite Status']"
                  @click="SortSelected('inviteStatus', 3)"
                  id="3"
                >
                  <div class="sort_block">
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.invite status") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </div>
                </th> -->
                 <!-- <th
                  v-if="selectedcolumnobj['Consent Status']"
                  @click="SortSelected('consnetstatus', 3)"
                  id="3"
                >
                  <div class="sort_block">
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.consnetstatus") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </div>
                </th> -->
                <th
                  v-if="selectedcolumnobj['Milestone']"
                  @click="SortSelected('milestone', 8)"
                  id="8"
                >
                  <div class="sort_block">
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.milestone") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </div>
                </th>
                <th
                  v-if="selectedcolumnobj['Cohort']"
                  @click="SortSelected('CohortName', 8)"
                  id="8"
                >
                  <div class="sort_block">
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.cohort") }}&nbsp;
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </div>
                </th>
                <th
                  v-if="selectedcolumnobj['Language']"
                  class="sort_block"
                  @click="SortSelected('language', 4)"
                  id="4"
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.language") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th
                  v-if="selectedcolumnobj['Country']"
                  class="sort_block"
                  @click="SortSelected('country', 5)"
                  id="5"
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.country") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th
                  v-if="selectedcolumnobj['Investigator']"
                  class="sort_block"
                  @click="SortSelected('nurseName', 6)"
                  id="6"
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.investigator") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th
                  v-if="selectedcolumnobj['Screening Date']"
                  class="sort_block"
                  @click="SortSelected('screeningDate', 7)"
                  id="7"
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.screening date") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th
                  v-if="selectedcolumnobj['Enrolment Date']"
                  class="sort_block"
                  @click="SortSelected('enrollmentDate', 8)"
                  id="8"
                >
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.enrolment date") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Active'] && roleprivileges.includes('Subjects Active')" class="text-center">
                  {{ $t("navigations.active") }}
                </th>
                  <th v-if="selectedcolumnobj['Active'] && roleprivileges.includes('Subjects Activate Account')">
                  {{ $t("navigations.activate account") }}
                </th>
                <!-- <th class="text-center">Video Call</th> -->
                <th
                  class="text-center"
                  v-if="roleprivileges.includes('Subjects Schedule')"
                >
                  {{ $t("navigations.profile") }}
                </th>
                <th
                  class="text-center"
                  v-if="roleprivileges.includes('Subjects Complete')"
                >
                  {{ $t("navigations.complete") }}
                </th>
                <th
                  class="text-center"
                  v-if="
                    !roleprivileges || roleprivileges.includes('Subjects Edit')
                  "
                >
                  {{ $t("navigations.edit") }}
                </th>
                <th
                  class="text-center"
                  v-if="roleprivileges.includes('Subjects Withdraw')"
                >
                  {{ $t("navigations.withdraw") }}
                </th>
                <th class="text-center"
                 v-if="roleprivileges.includes('Subjects Change Status')">
                  {{ "Change Status" }}
                </th>
                <th
                  class="text-center"
                  v-if="roleprivileges.includes('Audit Trail Subjects')"
                >
                  {{ $t("navigations.audit trail") }}
                </th>
             
                <th
                  class="text-center"
                  v-if="
                    !roleprivileges ||
                      roleprivileges.includes('Subjects Delete')
                  "
                >
                  {{ $t("navigations.delete") }}
                </th>
                <!-- <th v-if="roleprivileges.includes('Subjects Add Document')">{{ $t('navigations.documents') }}</th> -->
                <th
                  v-if="
                    roleprivileges.includes('Subjects Manage Folder & Document')
                  "
                  class="text-center"
                >
                  {{ $t("navigations.document") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="patient in patientLists" :key="patient.studyId">
                <td v-if="selectedcolumnobj['Site Code']">
                  {{ patient.siteCode }}
                </td>
                <td v-if="selectedcolumnobj['Subject ID']">
                  {{ patient.subjectId }}
                </td>
                <td v-if="selectedcolumnobj['Status']">{{ patient.status }}</td>
                 <!-- <td v-if="selectedcolumnobj['Invite Status']">{{ patient.inviteStatus }}</td>
                 <td v-if="selectedcolumnobj['Consent Status']">{{ patient.consentStatus }}</td> -->
                 
                <td v-if="selectedcolumnobj['Milestone']">{{ patient.milestone }}</td>
                   <td v-if="selectedcolumnobj['Cohort']">
                      <span v-if="patient.cohortName">
                        {{ patient.cohortName }}
                        <span v-if="patient.cohortCode">({{ patient.cohortCode }})</span>
                      </span>
                    </td>
  
                <td v-if="selectedcolumnobj['Language']">
                  {{ patient.language }}
                </td>
                <td v-if="selectedcolumnobj['Country']">
                  {{ patient.country }}
                </td>
                <td v-if="selectedcolumnobj['Investigator']">
                  {{ patient.nurseName }}
                </td>
                <td v-if="selectedcolumnobj['Screening Date']">
                  {{ filter(patient.screeningDate) }}
                </td>

                <td v-if="selectedcolumnobj['Enrolment Date']">
                  {{ filter(patient.enrollmentDate) }}
                </td>
                <td v-if="selectedcolumnobj['Active'] && roleprivileges.includes('Subjects Active')" class="text-center">
                  <div class="i-checks">
                    <input
                      type="checkbox"
                      v-model="patient.active"
                      onclick="return false"
                    />
                  </div>
                </td>
                   <td v-if="roleprivileges.includes('Subjects Activate Account')" class="text-center">
  <!-- Show Activate Account icon -->
  <template v-if="!patient.isSubjectActivated">
    <i
      class="fa fa-plus-circle edit-delete"
      @click.prevent="openInvitePopup(patient)"
      title="Activate Account"
    ></i>
  </template>

  <!-- Show Activated badge -->
<template v-else>
 Activated
</template>
</td>
                <!-- <td class="text-center">
                  <i
                    class="fa fa-video-camera edit-delete"
                    @click.prevent="
                      openVideoCallSchedulePopup(patient.patientId)
                    "
                  ></i>
                </td> -->
                <!-- <td
                  v-if="roleprivileges.includes('Subjects Schedule')"
                  class="text-center"
                >
                  <i
                    class="fa fa-calendar edit-delete"
                    v-if="patient.active && isVisitCreated > 0"
                      @click="gotosubjecttree(patient.patientId, patient.siteId)"
                  ></i>
                </td> -->
                <td
                  v-if="roleprivileges.includes('Subjects Schedule')"
                  class="text-center"
                >
                  <!-- <template v-if="patient.active && isVisitCreated > 0"> -->
                     <template v-if="patient.active">
                    <i
                      class="fa fa-calendar edit-delete"
                      @click="gotosubjecttree(patient.patientId, patient.siteId)"
                    ></i>
                  </template>

                  <span v-else>
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                </td>
                <td
                  v-if="roleprivileges.includes('Subjects Complete')"
                  class="text-center"
                >
                  <i
                    v-if="
                      patient.status == 'Enrolled' ||
                        patient.status == 'Visit Ongoing'
                    "
                    class="fa fa-check-square-o edit-delete"
                    @click="completepatient(patient.patientId)"
                  ></i>
                </td>

                <td
                  class="text-center"
                  v-if="
                    !roleprivileges || roleprivileges.includes('Subjects Edit')
                  "
                >
                  <i
                    v-if="patient.status != 'Withdrawn'"
                    class="fa fa-edit edit-delete"
                    @click="editPatient(patient.patientId)"
                  ></i>
                </td>

                <td
                  v-if="roleprivileges.includes('Subjects Withdraw')"
                  class="text-center"
                >
                  <!-- <i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i> -->
                  <i
                    v-if="
                      patient.status != 'Withdrawn' &&
                        patient.status != 'Completed'
                    "
                    class="fa fa-user-times edit-delete"
                    @click="withdrawPatient(patient.patientId)"
                  ></i>
                </td>
                <td  v-if="roleprivileges.includes('Subjects Change Status')" class="text-center">
                  <i
                    class="fa fa-external-link-square edit-delete"
                    style="color: #a13b7c"
                    @click.prevent="
                      openChangeStatusmodal(
                        patient.patientId,
                        'Subject',
                        patient.status
                      )
                    "
                  ></i>
                </td>
                <td
                  v-if="roleprivileges.includes('Audit Trail Subjects')"
                  class="text-center"
                >
                  <i
                    class="fa fa-eye edit-delete"
                    @click="openModelaudit(patient.patientId)"
                  ></i>
                </td>
                <!-- <td class="text-center">
                  <i
                    class="fa fa-eye edit-delete"
                    @click="
                      fhir(
                        patient.subjectId,
                        patient.siteCode,
                        patient.patientId,
                        patient.siteId
                      )
                    "
                  ></i>
                </td> -->
                <td
                  class="text-center"
                  v-if="
                    !roleprivileges ||
                      roleprivileges.includes('Subjects Delete')
                  "
                >
                  <i
                    v-if="patient.status == 'New'"
                    class="fa fa-trash edit-delete"
                    @click="deletePatient(patient.patientId)"
                  ></i>
                </td>
                <!-- <td class="text-center" v-if="roleprivileges.includes('Subjects Add Document')">
                  <i
                    class="fa fa-calendar edit-delete"
                    @click="documentPage(patient.patientId)"
                  ></i>
                </td> -->
                <td
                  v-if="
                    roleprivileges.includes('Subjects Manage Folder & Document')
                  "
                  class="text-center"
                >
                  <i
                    @click="
                      folderList(
                        patient.patientId,
                        patient.subjectId,
                        patient.siteCode
                      )
                    "
                    title="Document"
                    class="fa fa-folder edit-delete"
                  >
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!------ pagination -------->
        <div class="row mt-3 mx-0" v-if="patientLists.length != 0">
          <div class="col-lg-12 mx-0 px-0">
            <div
              class="dataTables_paginate paging_simple_numbers pagination float-right"
            >
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination
                  v-model="currentPage"
                  :pages="totalPages"
                  :range-size="1"
                  active-color="#618bd7"
                  @update:modelValue="loadPage"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- pagin -->
      </div>
      <!-- Audit trail details modal starts -->
      <div v-if="auditpopup == true" class="audit__details__modal__wrapper">
        <div class="audit__details__modal__container">
          <div
            class="audit__details__modal__title d-flex justify-content-between py-2 px-3"
          >
            <h4 class="my-0">{{ $t("navigations.audit details") }}</h4>
            <div class="cursor-pointer">
              <span class="tooltip-wrapper pointer" style="float:right">
              <i
                class="fa fa-times"
              
                @click.prevent="closemodallll()"
              ></i>
              <span class="custom-tooltip closetooltipposition">Close</span>
              </span>
            </div>
          </div>
          <!-- Popup -->
          <div
            class="audit__details__modal__content p-3"
            :class="{ heightBig: changeHeight }"
          >
            <div class="table-responsive">
              <table class="table table-hover issue-tracker">
                <tbody>
                  <tr
                    v-for="audit in auditLists"
                    :key="audit.studyId"
                    class="cursor-pointer"
                  >
                    <td @click="openModelauditOps(audit.id)">
                      <span class="d-block"
                        ><strong> {{ audit.loggedInUserName }}</strong></span
                      >
                    </td>
                    <td @click="openModelauditOps(audit.id)">
                      <div>
                        <small>{{ filter(audit.createdAt) }}</small>
                      </div>
                      <div>
                        <small>{{ toTime(audit.createdAt) }}</small>
                      </div>
                    </td>
                    <td
                      v-if="audit.operation == 'Update'"
                      @click="openModelauditOps(audit.id)"
                    >
                      <span class="badge badge-primary">{{
                        audit.operation
                      }}</span>
                    </td>
                    <td
                      v-if="audit.operation == 'Delete'"
                      @click="openModelauditOps(audit.id)"
                    >
                      <span class="badge badge-danger">{{
                        audit.operation
                      }}</span>
                    </td>
                    <td
                      v-if="audit.operation == 'Insert'"
                      @click="openModelauditOps(audit.id)"
                    >
                      <span class="badge badge-warning-light">{{
                        audit.operation
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--  popup -->
         <div
      class="audit__history__modal__wrapper"
      v-if="audithistortpopup == true"
    >
      <div class="audit__history__modal__container">
        <div
          class="audit__history__modal__title d-flex justify-content-between py-2 px-3"
        >
          <h4 class="my-0">{{ $t("navigations.audit trail") }}</h4>
          <div class="cursor-pointer" title="Close">
            <i class="fa fa-times" @click.prevent="closehistorymodal()"></i>
          </div>
        </div>
        <!-- test -->

        <!-- Popup -->
        <div class="audit__history__modal__contents p-3">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.field name") }}</strong>
                  </th>
                  <th>
                    <strong>{{ $t("navigations.old value") }}</strong>
                  </th>
                  <th>
                    <strong>{{ $t("navigations.new value") }}</strong>
                  </th>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.subject id") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.SubjectId }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.SubjectId }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.enrolment date") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ filter(auditHistoryLists.oldValue.EnrollmentDate) }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ filter(auditHistoryLists.newValue.EnrollmentDate) }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.country") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.Country }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.Country }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.investigator") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.NurseName }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.NurseName }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.pre visit") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.PreVisit }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.PreVisit }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.post visit") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.PostVisit }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.PostVisit }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.city") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.City }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.City }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.post/zip code") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.ZipCode }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.ZipCode }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.language") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.Language }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.Language }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.subject notes") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.PatientNotes }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.PatientNotes }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <tr>
                  <th>
                    <strong>{{ $t("navigations.language code") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.LanguageCode }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.LanguageCode }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <!-- <tr>
                  <th>{{ $t('navigations.language')}}</th>
                  <td>English</td>
                  <td>English</td>
                </tr> -->
                <tr>
                  <th>
                    <strong>{{ $t("navigations.active") }}</strong>
                  </th>
                  <td v-if="auditHistoryLists.oldValue">
                    {{ auditHistoryLists.oldValue.Active }}
                  </td>
                  <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.newValue">
                    {{ auditHistoryLists.newValue.Active }}
                  </td>
                  <td v-else>{{}}</td>
                </tr>
                <!-- <tr>
                  <th>{{ $t('navigations.create schedule')}}</th>
                  <td v-if="auditHistoryLists.oldValue">{{auditHistoryLists.oldValue.Active}}</td>
                    <td v-else>{{}}</td>
                  <td v-if="auditHistoryLists.oldValue">Yes</td>
                    <td v-else>{{}}</td>
                </tr> -->
              </thead>
            </table>
          </div>
        </div>

        <!-- Modal -->
      </div>
    </div>
    </div>
        </div>
 </div>
<!-- DOCUMENT GRID -->
<!-- <div class="row mt-3" id="document">
  <div class="col-lg-12 pr-1 mb-2">
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5 class="mt-1">{{ $t("navigations.documents") }}</h5>
        <div class="d-flex">
          <span class="position-relative cursor-pointer me-2" @click="openDocumetUploadModel">
            <img width="17" height="17" src="../../assets/img/create.png" alt="Create" />
            <div class="tool-tip">{{ $t("navigations.upload consent document") }}</div>
          </span>
        </div>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>{{ $t("navigations.document file name") }}</th>
                <th>{{ $t("navigations.document title") }}</th>
                <th>{{ $t("navigations.created date") }}</th>
                <th>{{ $t("navigations.delete") }}</th>
              </tr> 
            </thead>
            <tbody>
              <tr v-for="document in documentList" :key="document.id || document.documentId || document.formId">
                <td>{{ document.fileName || document.name || '-' }}</td>
                <td>{{ document.formName || document.documentTitle || '-' }}</td>
                <td>{{ formatdatetime(document.uploadedAt || document.CreatedAt) }}</td>
                <td class="text-center">
                  <i
                    class="fa fa-trash edit-delete"
                    aria-hidden="true"
                    @click="deleteDocument(document.id || document.documentId)"
                  ></i>
                </td>
              </tr>
              <tr v-if="showDocumentLoading">
                <td colspan="4" class="text-center">
                  <img src="../../assets/img/loading.gif" width="20" alt="Loading..." /> {{ $t("navigations.loading documents") }}...
                </td>
              </tr>
              <tr v-else-if="documentList.length === 0">
                <td colspan="4" class="text-center">{{ $t("navigations.no documents found") }}</td>
              </tr>
            </tbody>
           </table>
        </div>
        <div class="row mt-3 mx-0" v-if="documentList.length != 0">
          <div class="col-lg-12 mx-0 px-0">
            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination
                  v-model="documentCurrentPage"
                  :pages="documentTotalPages"
                  :range-size="1"
                  active-color="#618bd7"
                  @update:modelValue="loadDocumentPage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
 

    </div>
    <!--  popup -->
  <CreateVideoCallSchedulePopUp
    v-if="CreateVideoCallSchedulePopUp == true"
    @closeModal="CreateVideoCallSchedulePopUp = false"
    :patientid="selectedPatientId"
    :fromPage="'SubjectList'"
  />
    <!-- Change site status  -->
  <ChangeSchedulestatus
    v-if="showChangeSchedule"
    :statusType="statusType"
    :changeStatus="changeStatus"
    :selectedSubId="SubId"
    @changeStatus="changedStatus()"
    @closeModal="closeChangeScheduleModal()"
  />
  <!-- End of Change site status  -->
  <managePatientModal
    v-if="showPatientModal"
    @closeModal="closepatientmodel()"
    :patientId="selectedPatientId"
  />
  <ActivateAccountPopup
  v-if="showActivatePopup"
  :patient="patientForActivation"
  @close="showActivatePopup = false"
  @saved="handleActivationSaved"
/>
  <!-- <consentdocumentupload
  v-if="documentUploadpopup"
  :documentTitle="patient?.subjectId || ''"
  :description="`Consent document for subject ${patient?.subjectId}`"
  :docid="patient?.patientId || ''"
  :siteCode="patient?.siteCode || ''"
  @uploadlibactive="handleCloseDocumentUpload"
/> -->
</template>
<script src="./SiteUserDashboard.js"></script>
<style scoped>
.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.widgetmargin {
  margin-top: -13px !important;
}

.style1 {
  background-color: black !important;
  color: #ffffff;
}
.btn-view {
  color: #fff !important;
  background-color: #bb458f !important;
  border-color: #bb458f !important;
}
.btn-view:hover {
  color: #fff;
  background-color: #666ccb;
  border-color: #666ccb;
}
.btn-view:active {
  color: rgb(255, 255, 255) !important;
  background-color: #dda2c7 !important;
  border-color: #dda2c7 !important;
}

.titlemsg {
  border-color: #e7eaec;
  margin-bottom: 0;
  padding: 20px 20px;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  margin-left: 0px !important;
  margin-top: 0px !important;
  padding-left: 10px;
}
.padding_bottom {
  padding-bottom: 2rem;
}
.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
}
.ibox-title h5:hover {
  background-color: inherit;
  padding: 0;
  cursor: not-allowed;
}
.titlemsg {
  font-size: 15px;
  font-weight: bold;
  color: var(--primary-color);
}
.switchbtn {
  background-color: #bb458f !important;
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
}
.switchbtn:active {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}
.switchbtn:hover {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}
.queryhover:hover {
  color: #3c4192 !important;
  -webkit-transition: color ease-in 400ms;
  transition: color ease-in 400ms;
  cursor: pointer;
}

.widgetminheight {
  min-height: 102px;
}
.graphbutton{
width: fit-content;
padding: 3px;
cursor:pointer;
}
.graphbtncontainer{
display: flex;
gap: 5px;
}
img{
  margin-left: 0px !important;
}
.selectdefault{
  left: 0;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn-setdefault {
  position: relative;
  padding:0.2rem 0.4rem;
  text-align: center;
  font-size:0.7rem;
  background-color: #ec4758;
  color: white !important;
  border-radius:3px;
}
.ibox-content h1{
  font-weight:400;
  color:#676a6c
}
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}

.page-links {
  border-radius: 0px;
}

/*pagination styles*/
.pagination {
  margin: 0;
}

.Page,
.PaginationControl {
  border: 1px solid #e7eaec;
}

.Page-active {
  padding: .6rem;
  color: #ffffff;
  border: 1px solid var(--pagination-active-clr);
  border-radius: inherit;
  margin: 0;
}

.Page {
  padding: .6rem;
  border-radius: inherit;
  margin: 0;
}

.PaginationControl {
  padding: 0.07rem;
}

.create-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}

.form-control {
  padding: 0.2rem 0.75rem !important;
}

.form-select {
  border-radius: 0 !important;
  padding: 0.2rem 0.75rem !important;
}

.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}

.cursor-pointer {
  cursor: pointer;
}

.position-relative {
  position: relative;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.closetooltipposition{
  bottom: -10px !important;
 
}

/* .modal__container22 {
  width: 49%;
  max-width: 30%;
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
  overflow-x:hidden;
} */
.modal__container22 {
  width: 33%;
  max-width: 30%;
  position: fixed;
  height: 20% !important;
  margin-top: -550px !important;
  margin-left: 409px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}

.modal__container23 {
  width: 66%;
  max-width: 62%;
  position: fixed;
  height: -14% !important;
  margin-top: -683px !important;
  margin-left: 140px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}

.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}

.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.audit__details__modal__container {
  width: min(90%, 365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.heightBig {
  overflow-y: scroll;
  height: 250px;
}

.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}

.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000;
}

.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.headingunderline {
  text-decoration-line: underline;
}

.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  width: min(50%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.modal__title {
  background-color: #618bd7;
  color: #fff;
}

.save_btn {
  text-align: center;
  background-color: #145faf !important;
  border-color: #145faf !important;
  color: white !important;
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out !important;
}

.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
}

.save_btn:not(:disabled):hover,
.save_btn:focus:focus-visible {
  background-color: #145faf !important;
  border-color: #145faf !important;
}
.nav-tabs {
    border-bottom: none;
}
.nav-tabs li {
    margin-bottom: 0;
    list-style: none;
}
.nav-tabs li a {
    margin-right: 4px;
    line-height: 1.42857143;
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
    padding: 6px 12px;
    cursor: pointer;
    display: block;
    color: #555;
}
.nav-tabs li a.activeTab {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs li a:hover {
    background-color: #eee;
}

</style>
